<div #trigger class="ui-prescriber-array-input-container ui-secondary" (click)="eventOpenOptions()">
    @if (searching) {
        <div class="ui-prescriber-array-input-items">
            <div class="ui-badge" skeletonLoaderPipe="rect">Carregando...</div>
        </div>
    } @else {
        <div class="ui-prescriber-array-input-placeholder">{{ placeholder }}</div>
        @if (getSelectedPrescriberIds().length) {
            <div class="ui-prescriber-array-input-items">
                @for (prescriberId of getSelectedPrescriberIds(); track prescriberId) {
                    <div class="ui-badge">
                        <span>{{ getPrescriberName(prescriberId) }}</span>
                        <i class="ui-icon uii-trash-alt" (click)="eventRemovePrescriber(prescriberId, $event)"></i>
                    </div>
                }
            </div>
        }
    }
</div>

<ng-template #dropdownTemplate>
    <div class="ui-select-menu">
        <div class="ui-field ui-secondary ui-field-without-border">
            <i class="ui-icon uii-search"></i>
            <input type="text" class="ui-select-menu-search-input" placeholder="Buscar prescritor..." (input)="eventFilterChanged($event)"/>
        </div>

        <div class="ui-select-options" [ngClass]="{ 'ui-select-searching-options': searching }">
            @for (prescriber of prescribers; track prescriber._id) {
                <div class="ui-select-option" (click)="eventPrescriberChanged(prescriber)" [ngClass]="{'ui-badge-active': hasPrescriber(prescriber._id)}">
                    <div>
                        <div class="ui-title">{{ prescriber.name }}</div>
                        <span class="ui-sub-title">{{ prescriber.email }}</span>
                    </div>
                </div>
            }
            @if (!searching && prescribers.length === 0) {
                <div class="ui-empty-container">Nenhum prescritor encontrado</div>
            }
        </div>
    </div>
</ng-template>
